import { useTranslation } from "react-i18next";
import { Document, Page, Text, View, Image, StyleSheet, PDFDownloadLink, Link, Font, pdf, BlobProvider, Svg, Path } from '@react-pdf/renderer';
import QRCode from 'qrcode'
import { saveAs } from 'file-saver';

// register fonts
import Avenir from './../assets/AvenirNext-Regular.ttf'
import AvenirCond from './../assets/AvenirNextLTPro-Cn.ttf'
import Logo from "../Icons/LogoPDF";
import { encodeCode, getMaterialBySKU, getThumbnail, makeFilterNamePDF, normalizeFractions } from "../functions";
import i18n from "../i18n";
Font.register({ family: 'Avenir', src: Avenir });
Font.register({ family: 'AvenirCond', src: AvenirCond });

export async function CreatePDF(model, currMaterials, allMaterials, category, filters, image, duotonChoice) {
    let today = new Date();
    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, "0"); // +1 car getMonth() commence à 0
    let day = String(today.getDate()).padStart(2, "0");
    let fullDate = `${year}-${month}-${day}`;

    const code = encodeCode(model, currMaterials, duotonChoice);
    const codeLink = window.location.href.split('?')[0] + "?code=" + code + "&lang=" + i18n.language;

    const zePDF = <PDFmaker duotonChoice={duotonChoice} codeLink={codeLink} model={model} currMaterials={currMaterials} image={image} category={category} allMaterials={allMaterials} filters={filters} fullDate={fullDate} />;


    // PROD ////////////////////////////////////////////////////////////////////////
    const namePDF = `${fullDate}_${model.model.name.replace(/ /g, '-')}_TricaFurniture.pdf`;
    pdf((
        zePDF
    )).toBlob().then(blob => saveAs(blob, namePDF))
    // PROD ////////////////////////////////////////////////////////////////////////

    // TESTING /////////////////////////////////////////////////////////////////////
    // const zeBlob = await pdf(zePDF).toBlob();
    // const url = URL.createObjectURL(zeBlob);
    // window.open(url, '_blank');
    // TESTING /////////////////////////////////////////////////////////////////////
}

function PDFmaker({ model, currMaterials, allMaterials, category, filters, fullDate, image, codeLink, duotonChoice }) {
    const { t, i18n } = useTranslation();

    const isDuoton = duotonChoice === "mono" ? false : model.model.duoton;

    const optName = filters.length > 0 ? makeFilterNamePDF(filters, model.model.filters) : model.option.name[i18n.language];
    let QR;
    QRCode.toDataURL(codeLink, { errorCorrectionLevel: 'S', margin: 0, color: { dark: "#515147", light: "#eeeadf" } }, function (err, url) {
        QR = url;
    })

    return (
        <Document producer='Propulsé par Edge Dimension' creator='Trica Furniture - Edge Dimension'>
            <Page orientation="portrait" size="LETTER">
                <View style={{ display: 'flex', flexDirection: "column", height: 680, position: "absolute", left: 40, right: 40, top: 40 }}>
                    <View style={{ position: "absolute", left: 0, top: -6 }}>
                        <Text style={{ fontFamily: "Avenir", fontSize: 30, color: "#515147" }}>{model.model.name}</Text>
                        <Text style={{ fontFamily: "Avenir", fontSize: 15, color: "#515147", marginTop: -6 }}>{t(model.model.type)}</Text>
                    </View>
                    <Text style={{ position: "absolute", right: 0, top: 0, color: "#515147", fontFamily: "Avenir", fontSize: 12 }}>{t("createdOn") + " " + fullDate}</Text>
                    <Image src={image} style={{ zIndex: -1, height: 300, width: "100%", objectFit: "contain" }} />
                    <View style={{ display: "flex", flexDirection: "column", width: "100%", marginTop: 20 }}>
                        <Elements type="simple" option={optName} />
                        {category.map((el, i) => {
                            let numEnd = "";
                            if (isDuoton && (el.materials?.includes("fabric") || el.materials?.includes("leather"))) {
                                numEnd = el.id;
                            }
                            // const mtl = numEnd ? numEnd === el.id && el.materials.find(key => currMaterials[key]) : el.materials.find(key => currMaterials[key]);
                            const mtl = el.materials.find(key => currMaterials[key + numEnd]);
                            const goodMtl = getMaterialBySKU(allMaterials, currMaterials[mtl + numEnd].code);
                            // console.log(goodMtl, mtl, numEnd, currMaterials)
                            return (
                                <Elements key={i} type="material" name={el.name[i18n.language]} material={goodMtl} />
                            )
                        })}
                        <Line />
                    </View>
                    <View style={{ position: "absolute", bottom: 0, left: 0, right: 0, width: "100%", display: "flex", justifyContent: "center" }}>
                        <Link href={codeLink} style={{ textDecoration: "none", display: "flex", gap: 5, flexDirection: "column", alignItems: "center", width: "100%" }}>
                            <View style={{ backgroundColor: "#eeeadf", width: 80, height: 80, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Image style={{ height: '65', width: '65', right: 0 }} src={QR} />
                            </View>
                            <Text style={{ fontFamily: "Avenir", fontSize: 10, color: "#515147" }}>{t("visualize")}</Text>
                        </Link>
                    </View>
                </View>
                <MyFooter />
            </Page>
        </Document>
    )
}

function MyFooter(props) {
    const { i18n, t } = useTranslation();
    return (
        <View style={{ borderTop: "1px solid #515147", paddingTop: 6, position: "absolute", left: 40, right: 40, bottom: 40, flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Logo />
            <Text style={{ fontFamily: "AvenirCond", width: 230, textAlign: "center", fontSize: 9, position: "absolute", top: 6, left: "50%", marginLeft: -115 }}>{t("footer")}</Text>
            <Link style={{ marginTop: -5, fontFamily: "Avenir", color: "#939598", textDecoration: "none", fontSize: 12 }} src={"https://www.tricafurniture.com/" + i18n.language}>www.tricafurniture.com</Link>
        </View>
    )
}

function Elements({ type, name, material, option }) {
    const { i18n, t } = useTranslation();
    // console.log(material)
    return (
        <View style={{ color: "#515147", fontFamily: "Avenir", display: "flex", flexDirection: "column" }}>
            <Line />
            <View style={{ fontSize: 14, display: "flex", flexDirection: "row", justifyContent: 'space-between', alignItems: "center", padding: "0 20px", height: 50 }}>
                <Text>{type === "simple" ? "Option" : name.split(" [")[0]}</Text>
                {type === "simple" ?
                    <Text>{normalizeFractions(option)}</Text>
                    :
                    <View style={{ display: "flex", flexDirection: "row", gap: 15, alignItems: "center" }}>
                        <Text style={{ textTransform: "capitalize" }}>{material.name[i18n.language].toLowerCase()}</Text>
                        <View style={{ width: 102, height: 34, borderRadius: 4, backgroundColor: "#515147", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Image src={getThumbnail(material, "pdf")} style={{ width: 100, height: 32, borderRadius: 3, objectFit: "cover" }} />
                        </View>
                    </View>
                }
            </View>
        </View>
    )
}

function Line() {
    return (
        <View style={{ width: "100%", height: 1, backgroundColor: "#515147" }}></View>
    )
}